// Items rendered in the credibility marquee beneath the hero: organizations
// and publications that have recognized, acquired, certified, or featured the work.
// Items with a `logo` show the brand mark alongside the name.
import qualcomm from '../assets/logos/qualcomm.svg';
import google from '../assets/logos/google.svg';
import ieee from '../assets/logos/ieee.svg';
import dev from '../assets/logos/dev.svg';

export const recognitionData = [
    { label: 'IEEE Senior Member', logo: ieee },
    { label: 'U.S. DOT · FMCSA Registry' },
    { label: 'Qualcomm', logo: qualcomm },
    { label: 'AAMP Global' },
    { label: 'Google Android Enterprise', logo: google },
    { label: 'AI Time Journal' },
    { label: 'Outlook India' },
    { label: 'Telematics Wire' },
    { label: 'Towards AI' },
    { label: 'DEV Community', logo: dev },
];
